import React from "react";
import format_date_short from "../../App/validation/format_date_short";

export default function C_V_DATE({ value, field, id }) {
  if (!value) return null;

  // 1. Flip YYYY-MM-DD (or YYYY/MM/DD) to DD-MM-YYYY safely
  const rawFormatted =
    typeof value === "string" ? value.split(/[-/]/).reverse().join("-") : "";

  // 2. Get the textual short date (e.g., 31 DES 2025)
  const formattedDate = format_date_short(value);

  // 3. Combine them
  let displayString = rawFormatted;
  if (formattedDate !== null) {
    displayString = `${rawFormatted} (${formattedDate})`
  }

  return (
    <span
      title={displayString}
      style={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        lineHeight: "1.5",
        padding: "0 8px",
        boxSizing: "border-box",
      }}
    >
      {displayString}
    </span>
  );
}
